// Copied from https://github.com/epoberezkin/fast-json-stable-stringify/blob/master/index.js and then stripped to optimize for speed.

export default function (obj) {
    let seen = new Set();
    return (function stringify (node, nooverride) {
        if (node && typeof node.toJSON === 'function') {
            node = node.toJSON();
        }

        if (node === undefined) {
            return;
        }
        if (node === null) {
            return 'null';
        }
        if (typeof node === 'number') {
            return isFinite(node) ? '' + node : 'null';
        }
        if (typeof node !== 'object') {
            return JSON.stringify(node);
        }
        if (Array.isArray(node)) {
            let out = '[';
            for (let i = 0; i < node.length; i++) {
                if (i) {
                    out += ',';
                }
                out += stringify(node[i]) || 'null';
            }
            return out + ']';
        }

        if (!nooverride && typeof node.stableStringify === 'function') {
            return node.stableStringify(n => stringify(n, true));
        }

        if (seen.has(node)) {
            throw new TypeError('Converting circular structure to JSON');
        }
        seen.add(node);

        let keys = Object.keys(node).sort();
        let out = '';
        for (let i = 0; i < keys.length; i++) {
            let key = keys[i];
            let value = stringify(node[key]);

            if (!value) {
                continue;
            }
            if (out) {
                out += ',';
            }
            out += JSON.stringify(key) + ':' + value;
        }
        seen.delete(node);
        return '{' + out + '}';
    })(obj);
};
